export default __webpack_public_path__ + "static/media/i133vp.ad72bbd3.webp";